import each from "lodash/each";

export const Three60 = () => {
  const clickToLoad = document.getElementsByClassName("three60__info");
  if (!clickToLoad.length) return;

  each(clickToLoad, el => {
    el.addEventListener("click", () => {
      loadThree60Content(el.parentNode) && el.parentNode.removeChild(el);
    });
  });
};

const loadThree60Content = (group): boolean => {
  const content = group.getElementsByClassName("three60__content");
  if (!content.length) return;

  content[0].setAttribute("src", content[0].getAttribute("data-src"));
  content[0].classList.remove("three60__content--hidden");
  return true;
};
